import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import '../../../src/assets/js/modules/Core/scripts/nav';
import '../../../src/assets/js/modules/Core/scripts/shortlist';
import {
  checkCatfishLocation
} from '../../../src/assets/js/modules/Core/scripts/utilities';
import '../css/main.css';
import '../css/style.css';
import './jquery.validate';
import './sticky-functions';

window.checkCatfishLocation = checkCatfishLocation;

// =============menu mobile icon js==============

$(document).ready(function() {
  $('.nav-button').click(function() {
    $('#mySidenav').toggleClass('navbar-open')

    // Change hamburger button into close button or return to hamburger on close
    if ($('#nav-button-icon').attr("src") === "https://cdn.what-franchise.com/assets/images/misc/hamburger.png"){
      $('#nav-button-icon').attr("src", "https://cdn.what-franchise.com/assets/images/misc/close_nav.png");
      $('#nav-button-icon').css("width", "27px");
      dataLayer.push({'event': 'myTrackEvent', 'eventCategory': 'Header-Mobile', 'eventAction': 'Click', 'eventLabel': 'Open Navigation via hamburger'})
    } else {
      $('#nav-button-icon').attr("src", "https://cdn.what-franchise.com/assets/images/misc/hamburger.png")
      $('#nav-button-icon').css("width", "30px");
      dataLayer.push({'event': 'myTrackEvent', 'eventCategory': 'Header-Mobile', 'eventAction': 'Click', 'eventLabel': 'Close Navigation via hamburger'})
    }

    // Close the search window (if its open) and set search icon back to black
    if ($('.search_mobile').css('display') === 'block'){
      $('.search_mask').css('display', 'none');
      $('#mobile-search-icon').attr("src", "https://cdn.what-franchise.com/assets/images/misc/search_icon.png");
      $('.search_mobile').css('display', 'none');
      $('.search_mask').css('display', 'none');
    }
  }),
    $('.sidenav li .second-level')
      .css({
        cursor: 'pointer'
      })
      .on('click', function() {
        $(this)
          .parent()
          .toggleClass('submenu_open')
          .removeClass('close_item')
      }),
    $('.sidenav li .mp-back-second')
      .css({
        cursor: 'pointer'
      })
      .on('click', function() {
        $(this)
          .parent()
          .parent()
          .parent()
          .toggleClass('close_item')
          .removeClass('submenu_open')
      }),
    $('.submenu li .third-level')
      .css({
        cursor: 'pointer'
      })
      .on('click', function() {
        $(this)
          .parent()
          .toggleClass('submenu_third_open')
          .removeClass('close_item')
      }),
    $('.sidenav li .mp-back-thrid')
      .css({
        cursor: 'pointer'
      })
      .on('click', function() {
        $(this)
          .parent()
          .parent()
          .parent()
          .toggleClass('close_item')
          .removeClass('submenu_third_open')
      });
})

//=========================>customize.js=========================>

document.addEventListener('DOMContentLoaded', function() {
  var div,
    n,
    v = document.getElementsByClassName('youtube-player')

  for (n = 0; n < v.length; n++) {
    div = document.createElement('div')

    div.setAttribute('data-id', v[n].dataset.id)
    div.setAttribute('data-loc', v[n].dataset.loc)
    div.setAttribute('data-type', v[n].dataset.type)
    div.setAttribute('data-vimeo', v[n].dataset.vimeo)

    div.innerHTML = labnolThumb(v[n].dataset.id, v[n].dataset.loc)

    div.onclick = labnolIframe

    v[n].appendChild(div)
  }
})

function labnolThumb(id, location = null, type = null) {
  if (location == 'hp') {
    var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg" alt="Video Popup">',
      play =
        "<span> <i class='fa fa-play' aria-hidden='true'></i> <strong>LET'S GO!</strong> </span>"
  } else {
    var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
      play = '<div class="play"></div>'
  }

  return thumb.replace('ID', id) + play
}

function labnolIframe() {
  var type = this.dataset.type
  console.log(this.dataset);
  if(type !== 'why-franchising'){
    var iframe = document.createElement('iframe')
    var embed = 'https://www.youtube.com/embed/ID?autoplay=1'

    iframe.setAttribute('src', embed.replace('ID', this.dataset.id))
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '1')

    this.parentNode.replaceChild(iframe, this)
  } else {
    var iframe = document.createElement('iframe')
    var embed = 'https://player.vimeo.com/video/ID'

    iframe.setAttribute('src', embed.replace('ID', this.dataset.vimeo))

    this.parentNode.replaceChild(iframe, this)
  }

}

//home page tabs

function openCity(evt, cityName) {
  var i, tabcontent, tablinks

  tabcontent = document.getElementsByClassName('tabcontent')

  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = 'none'
  }

  tablinks = document.getElementsByClassName('tablinks')

  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(' active', '')
  }

  document.getElementById(cityName).style.display = 'block'

  evt.currentTarget.className += ' active'
}

//header searchbar

$(document).ready(function() {
  $('.search_click').click(function() {

    $('.navbar').css("display", "none");
    $('.message_info').css("visibility", "hidden");
        $('.search_hide').slideToggle('fast')

    return false
  })
})

$(document).ready(function() {
  $('.search_cancel').click(function() {
    $('.search_hide').css('display','none');
    $('.navbar').css("display", "block");
    $('.message_info').css("visibility", "visible");

    return false
  })
})

$(document).ready(function() {
  $('.mobile-search-button').click(function() {

    //toggle mask
    $('.search_mask').toggle();

    //Toggle between green and black search icon
    if ($('#mobile-search-icon').attr("src") === "https://cdn.what-franchise.com/assets/images/misc/search_icon.png"){
      $('#mobile-search-icon').attr("src", "https://cdn.what-franchise.com/assets/images/misc/search_icon_active.png");
    } else {
      $('#mobile-search-icon').attr("src", "https://cdn.what-franchise.com/assets/images/misc/search_icon.png");
    }

    //Show search bar
    $('.search_mobile').toggle();

    return false
  })
})
$(document).ready(function() {
  var prevScrollpos = window.pageYOffset;

  window.onscroll = function() {

    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos && $('.header_container').css('display') === "none") {
      //If they are scrolling up, show the mobile header
    $(".header_mobile").css('visibility','visible');

    //Else they're scrolling down - Check that the nav side bar isnt open, they aren't searching. If so,
    //hide the header once they scroll past 170px
    } else if (!$('.mySidenav').hasClass('navbar-open') && ($(".search_mask").css("display") ==="none")){
      if (currentScrollPos > 170){
      $(".header_mobile").css('visibility','hidden');
      }

    }
    prevScrollpos = currentScrollPos;
  }
})

$(document).ready(function() {
  $('.latest-video-carousel').owlCarousel({
    loop:false,
    margin:30,
    nav:true,
    navText: ["&#8249;","&#8250;"],
    responsive:{
      0:{
        items:2
      },
      600:{
        items:3
      },
      1000:{
        items:5
      }
    }
  })

  //Videos carousel
  $('.video-carousel').owlCarousel({
    loop:false,
    margin:30,
    nav:true,
    navText: ["&#8249;","&#8250;"],
    responsive:{
      0:{
        items:2
      },
      600:{
        items:3
      },
      1000:{
        items:4
      }
    }
  })

});



//Companies to Consider

$(document).ready(function() {
  $('.companiescarousel').owlCarousel({
    loop: true,

    margin: 10,

    responsiveClass: true,

    autoPlay: 3000,

    autoWidth: true,

    responsive: {
      0: {
        items: 2,

        //nav: true,

        margin: 5,

        nav: false
      },

      600: {
        items: 3,

        nav: false
      },

      768: {
        items: 3,

        nav: false
      },

      1000: {
        items: 3,

        nav: true,

        //loop: false,

        margin: 20
      },

      1200: {
        items: 4,

        nav: true,

        //loop: false,

        margin: 20
      }
    }
  })
})

//Companies to Consider end

//news_container carousel

$(document).ready(function() {
  $('.newscarousel').owlCarousel({
    loop: true,

    margin: 20,

    responsiveClass: true,

    //autoplay:true,

    autoWidth: true,

    responsive: {
      320: {
        items: 1,

        nav: true,

        autoWidth: false
      },

      480: {
        items: 2,

        nav: true,

        autoWidth: false
      },

      600: {
        items: 3,

        nav: true
      },

      1000: {
        items: 3,

        nav: true,

        //loop: false,

        margin: 20
      }
    }
  })
})

//news_container  carousel end

//news_container carousel

$(document).ready(function() {
  $('.directorycarousel').owlCarousel({
    loop: true,


    responsiveClass: true,

    autoPlay: 3000,

    //autoWidth:true,

    responsive: {
      0: {
        items: 1,

        nav: false,

        autoWidth: true
      },

      480: {
        items: 2,

        nav: false,

        autoWidth: true
      },

      600: {
        items: 3,

        nav: false,

        autoWidth: true
      },

      1000: {
        items: 5,

        nav: true,

        //loop: false,
      }
    }
  })
})

//news_container  carousel end

//Resales Available Today carousel

$(document).ready(function() {
  $('.resalescarousel').owlCarousel({
    loop: true,

    margin: 20,

    responsiveClass: true,

    autoPlay: 3000,

    autoWidth: true,

    responsive: {
      0: {
        items: 1,

        nav: true
      },

      480: {
        items: 2,

        nav: true
      },

      600: {
        items: 3,

        nav: true
      },

      1000: {
        items: 3,

        nav: true,

        //loop: false,

        margin: 30
      }
    }
  })
})

//Resales Available Today carousel end

//franchising-advice carousel

$(document).ready(function() {
  $('.advicecarousel').owlCarousel({
    loop: true,

    responsiveClass: true,

    autoPlay: 3000,

    autoWidth: true,

    responsive: {
      0: {
        items: 1,

        nav: true,

        margin: 20
      },

      480: {
        items: 1,

        nav: true,

        margin: 20
      },

      600: {
        items: 1,

        nav: true,

        margin: 30
      },

      1023: {
        items: 2,

        nav: true,

        margin: 30
      },

      1200: {
        items: 2,

        nav: true,

        //loop: false,

        margin: 30
      }
    }
  })
})

//franchising-advice carousel end

//shortlist-basket tablet carousel

$(document).ready(function() {
  $('.shortlistcarousel').owlCarousel({
    loop: true,

    margin: 20,

    responsiveClass: true,

    //autoPlay: 3000,

    autoWidth: true,

    responsive: {
      0: {
        items: 1,

        nav: false
      },

      600: {
        items: 2,

        nav: false
      },

      1023: {
        items: 2,

        nav: false
      }
    }
  })
})

//shortlist-basket tablet carousel end

//what franchise carousel

$(document).ready(function() {
  $('.what_franchisecarsoual_inner').owlCarousel({
    loop: true,

    margin: 20,

    responsiveClass: true,

    //autoPlay: 3000,

    //autoWidth:true,

    responsive: {
      0: {
        items: 1,

        nav: true
      },

      600: {
        items: 2,

        nav: true
      },

      1023: {
        items: 1,

        nav: true
      }
    }
  })
})

//what franchise carousel end

// Reports carousels
$(document).ready(function() {
  $('.reportcarousel').owlCarousel({
    loop: false,
    margin: 70,
    responsiveClass: true,
        autoWidth: true,
        nav: true,
        navElement: 'button',
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        dots: false,
    responsive: {
            735: {
                items: 4,
                center: false
            },
      0: {
                items: 1,
                margin: 20
      }
    }
  })
})

// Reports carousels end

//contact us

$(document).ready(function() {
  $('.contact_us_inner input[type="radio"]').click(function() {
    $('.contact_us_inner input[type="radio"]:not(:checked)')
      .parent()
      .removeClass('radio_active')

    $('.contact_us_inner input[type="radio"]:checked')
      .parent()
      .addClass('radio_active')
  })
})

//contact us end

//single entry sticky divs

$(document).ready(function() {
    $('.sticky-social').sticky({
        topSpacing: 120,

        zIndex: 2,

        stopper: '#stickystopper'
    }),
  $('.sticky').sticky({
    topSpacing: 10,

    zIndex: 2,

    stopper: '#stickystoper'
  }),
    $('.stickyfranchiseright').sticky({
      topSpacing: 19,

      zIndex: 2,

      stopper: '#stickystoper'
    }),
    $('.sticky-right').sticky({
      topSpacing: 10,

      zIndex: 3,

      stopper: '#sticky-bottom'
    }),
    $('.stickybar_tablet').sticky({
      topSpacing: 58,

      zIndex: 4,

      stopper: '.footer_outer'
    })
}),
  $('ul.expandible').each(function() {
    //load more View more franchising steps

    var e = $(this),
      n = e.find('li:gt(0)'),
      t = e.hasClass('expanded')

    n[t ? 'show' : 'hide'](),
      n.length > 0 &&
        e.append(
          $(
            '<li class="expand"><div>' +
              (t
                ? 'View less franchising steps &and;'
                : 'View more franchising steps &or;') +
              '</div></li>'
          ).click(function(t) {
            var a = e.hasClass('expanded')

            t.preventDefault(),
              $(this).html(
                a
                  ? 'View more franchising steps &or;'
                  : 'View less franchising steps &and;'
              ),
              e.toggleClass('expanded'),
              n.toggle()
          })
        )
  }),
  $(document).ready(function() {
    //shortlist-basket

    $('.remove_button').click(function() {
      $(this)
        .parent()
        .addClass('remove_selected')
    })
  }),
  $(document).ready(function() {
    //newsletter popup

    $('.close_popup').click(function() {
      $('#join_today_popup').addClass('pop_hide')
    }),
      $('.message_info span a.popupClick').click(function() {
        $('#join_today_popup').removeClass('pop_hide')
      })
  }),
  $(document).ready(function() {
    $('.video_close_popup').click(function() {
      $('#small_video_popup').addClass('video_pop_hide')
    }),
      $('.video_small_thumb a').click(function() {
        $('#small_video_popup').removeClass('video_pop_hide')
      }),
      $('.close_button_video_thumb').click(function() {
        $('#small_video_popup_right').addClass('video_pop_hide_small')
      }),
      $('.video_small_thumb a').click(function() {
        $('#small_video_popup_right').removeClass('video_pop_hide_small')
      })
  }),
  $(window).on('load',function() {
    //subscribe anchor link

    $(document).ready(function() {
      $('a[anchor]').click(function(e) {
        e.preventDefault()

        var n = $(this).attr('anchor'),
          t = $('div[name=' + n + ']').offset().top

        $('html, body').animate(
          {
            scrollTop: t
          },
          300
        )
      })
    })
  })

//jQuery time subscrine form

var current_fs, next_fs, previous_fs, left, opacity, scale, animating

$('.next').click(function() {
  if (animating) return !1
  ;(animating = !0),
    (current_fs = $(this).parent()),
    (next_fs = $(this)
      .parent()
      .next()),
    $('#progressbar li a')
      .eq($('fieldset').index(next_fs))
      .addClass('subscribe_active'),
    $('#progressbar span')
      .eq($('fieldset').index(next_fs))
      .addClass('subscribe_active'),
    next_fs.show(),
    current_fs.animate(
      {
        opacity: 0
      },
      {
        step: function(e, n) {
          ;(scale = 1 - 0.2 * (1 - e)),
            (left = 0 * e + '%'),
            (opacity = 1 - e),
            current_fs.css({
              position: 'absolute'
            }),
            next_fs.css({
              left: left,

              opacity: opacity
            })
        },

        duration: 800,

        complete: function() {
          current_fs.hide(), (animating = !1)
        },

        easing: 'easeInOutBack'
      }
    )
}),
  $('.previous').click(function() {
    if (animating) return !1
    ;(animating = !0),
      (current_fs = $(this).parent()),
      (previous_fs = $(this)
        .parent()
        .prev()),
      $('#progressbar li a')
        .eq($('fieldset').index(next_fs))
        .removeClass('subscribe_active'),
      $('#progressbar span')
        .eq($('fieldset').index(next_fs))
        .removeClass('subscribe_active'),
      previous_fs.show(),
      current_fs.animate(
        {
          opacity: 0
        },
        {
          step: function(e, n) {
            ;(scale = 0.8 + 0.2 * (1 - e)),
              (left = 0 * (1 - e) + '%'),
              (opacity = 1 - e),
              current_fs.css({
                left: left
              }),
              previous_fs.css({
                position: 'relative',

                opacity: opacity
              })
          },

          duration: 800,

          complete: function() {
            current_fs.hide(), (animating = !1)
          },

          easing: 'easeInOutBack'
        }
      )
  }),
  // $(document).ready(function() {
  // 	//shortlist scroll
  //
  // 	$('.scrollbars').ClassyScroll(), $('.home_scrollbars').ClassyScroll()
  // }),
  $('select').mousedown(function() {
    //zoom issue

    $('meta[name=viewport]').remove(),
      $('head').append(
        '<meta name="viewport" content="width=device-width, maximum-scale=1.0, user-scalable=0">'
      )
  }),
  $('select').focusout(function() {
    $('meta[name=viewport]').remove(),
      $('head').append(
        '<meta name="viewport" content="width=device-width, initial-scale=yes">'
      )
  })

function convertToPrice(price) {
  return Number(price).toLocaleString(undefined, { maximumFractionDigits: 2 })
}


//Subscribe form
function changeTab(evt, tabNo) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabNo).style.display = "block";
  evt.currentTarget.className += " active";
}

function validateStep1(){
  var title = document.getElementById("title").value;
  var fname = document.getElementById("fname").value;
  var lname = document.getElementById("lname").value;
  var phone = document.getElementById("phone").value;
  var email = document.getElementById("email").value;
  var job = document.getElementById("job").value;
  var coName = document.getElementById("coName").value;

  if(title == '0'){
    document.forms["msform"]["title"].className += " error";
  }else{
    document.forms["msform"]["title"].classList.remove("error");
  }
  if(fname == ''){
    document.forms["msform"]["firstname"].className += " error";
  }else{
    document.forms["msform"]["firstname"].classList.remove("error");
  }
  if(lname == ''){
    document.forms["msform"]["lastname"].className += " error";
  }else{
    document.forms["msform"]["lastname"].classList.remove("error");
  }
  if(phone == ''){
    document.forms["msform"]["telephone"].className += " error";
  }else{
    document.forms["msform"]["telephone"].classList.remove("error");
  }
  if(email == ''){
    document.forms["msform"]["email"].className += " error";
  }else{
    document.forms["msform"]["email"].classList.remove("error");
  }
  if(job == '0'){
    document.forms["msform"]["job"].className += " error";
  }else{
    document.forms["msform"]["job"].classList.remove("error");
  }
  if(coName == ''){
    document.forms["msform"]["companyname"].className += " error";
  }else{
    document.forms["msform"]["companyname"].classList.remove("error");
  }
  if(title != '0' && fname != '' && lname != '' && phone != '' && email != '' && job != '0' && coName != ''){
    changeTab(event, 'tab2');
    document.getElementById('progress-2').className += 'subscribe_active';
  }
}

function validateStep2(){
  var add1 = document.getElementById("add1").value;
  var add2 = document.getElementById("add2").value;
  var city = document.getElementById("city").value;
  var country = document.getElementById("country").value;
  var postcode = document.getElementById("postcode").value;

  if(add1 == ''){
    document.forms["msform"]["address"].className += " error";
  }else{
    document.forms["msform"]["address"].classList.remove("error");
  }
  if(add2 == ''){
    document.forms["msform"]["address2"].className += " error";
  }else{
    document.forms["msform"]["address2"].classList.remove("error");
  }
  if(city == ''){
    document.forms["msform"]["city"].className += " error";
  }else{
    document.forms["msform"]["city"].classList.remove("error");
  }
  if(country == ''){
    document.forms["msform"]["county"].className += " error";
  }else{
    document.forms["msform"]["county"].classList.remove("error");
  }
  if(postcode == ''){
    document.forms["msform"]["postcode"].className += " error";
  }else{
    document.forms["msform"]["postcode"].classList.remove("error");
  }

  if(add1 != '' && add2 != '' && city != '' && country != '' && postcode != ''){
    changeTab(event, 'tab3');
    document.getElementById('progress-3').className += 'subscribe_active';
  }
}
function backStep1(){
  changeTab(event, 'tab1');
  document.getElementById('progress-2').classList.remove('subscribe_active');
}
function backStep2(){
  changeTab(event, 'tab2');
  document.getElementById('progress-3').classList.remove('subscribe_active');
}


/* carousel sidebar js */
    var currentLeft = 0;
  var widthToMove = 320;
  if ("carouselSize" in window) {
    var maxSize = widthToMove * carouselSize;
  }

    function updateCarousel(movement){

      let elementsToGet = document.querySelectorAll(".carousel-container");

      if (movement === "right"){
        if ((currentLeft - widthToMove) <= (maxSize * -1)) {
          return;
        }
        currentLeft -= widthToMove;

    for (var x = 0; x < elementsToGet.length; x++){
      elementsToGet[x].style.left = currentLeft + "px";
    }

      }

      if (movement === "left"){
        if ((currentLeft + widthToMove) > 0){
          return;
        }
        currentLeft += widthToMove;
    for (var x = 0; x < elementsToGet.length; x++){
      elementsToGet[x].style.left = currentLeft + "px";
    }
      }

    }
window.onload = function () {
  var containers = document.querySelectorAll(".carousel-container");

  for (var x = 0; 0 < containers.length; x++){
    containers[x].addEventListener("touchstart", startTouch, false);
    containers[x].addEventListener("touchmove", moveTouch, false);
  }
}
  // Swipe Up / Down / Left / Right
  var initialX = null;
  var initialY = null;

  function startTouch(e) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  };

  function moveTouch(e) {
    if (initialX === null) {
      return;
    }

    if (initialY === null) {
      return;
    }

    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;

    var diffX = initialX - currentX;
    var diffY = initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      // sliding horizontally
      if (diffX > 0) {
        // swiped left
        updateCarousel("right");
      } else {
        // swiped right
        updateCarousel("left");
      }
    } else {
      // sliding vertically
      if (diffY > 0) {
        // swiped up
      } else {
        // swiped down
      }
    }

    initialX = null;
    initialY = null;

    e.preventDefault();
  };


  window.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.carousel-control-left') != null)  {
      document.querySelector('.carousel-control-left').addEventListener('click', function() {
        updateCarousel("left");
      })
      document.querySelector('.carousel-control-right').addEventListener('click', function() {
        updateCarousel("right");
      })
    }
  });
